// https://www.filestack.com/fileschool/react/react-file-upload/

// Third party modules;
import React from 'react';

// HelpBot modules;
import api from './api/api';
import app from './app';
import { Form, FORM, form_close } from './Form';

const TreeUpload = () => {

   const [file, set_file] = React.useState()
   const [json, set_json] = React.useState();

   const build = async ({ set_body, set_foot, warn, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;

      set_body(
         <div className="ask-henry-body-margin-bottom-x">
           {warn}
           <p className="ask-henry-body-margin-bottom-x">Select a file.</p>
           <input className="ask-henry-form-input" name="file" type="file" onChange={build_input_change} />
         </div>
      );

      set_foot(
         <>
           <button className="ask-henry-form-button" type="submit">Submit{app.who()}</button>
           <button className="ask-henry-form-button" onClick={form_close} >Cancel</button>
         </>
      );

   } // build();

   function build_input_change(event) {
      set_file(event.target.files[0])
   } // build_input_change();

   const check = ({ set_form, set_warn, ...args }) => {
      // The check() function validates the user input, if the input is bogus a warning message
      // is set, otherwise the form state is set to ENACT;

      if (!file) {
         set_warn('Select a file before you submit the form.');
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else {
         set_form(FORM.ENACT);// Send any requests to the API;
      }
   } // check();

   const enact = async ({ set_form, set_warn, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;

      var response = null;

      const form_data = new FormData();
      const headers   = { headers: { 'content-type' : 'multipart/form-data' } };

      form_data.append('file', file);
      form_data.append('fileName', file.name);

      response = await api.fetch('dbs/tree/upload/' + app.state.version_id, api.post(form_data), api.token(headers));

      if (!response.good) {
         if ('undefined' === typeof response.data.text) {
            set_warn('Unrecognized error returned from API.');
         } else {
            set_warn(response.data.text);
         }
         set_form(FORM.BUILD);
      } else {
         set_form(FORM.FINAL);
         set_json(response.data);
         app.set_state('status', 'Topic tree uploaded');
      }

   } // enact();

   const final = ({ set_body, set_foot, ...args }) => {
      // The final() function displays the final results and renders the close option;
      set_body(<p className="ask-henry-body-margin-bottom-x">{json.message}</p>);
      set_foot(<button className="ask-henry-form-button" onClick={form_close} >Close</button>);
   } // final();

   return <Form build={build} check={check} enact={enact} final={final}  title={'Upload Topic Tree' + app.who()} />

} // <TreeUpload />;

export default TreeUpload;
